var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5335 13.6575C118.071 31.8674 113.291 23.5801 113.291 60C113.291 96.4199 118.079 88.1326 86.5335 106.343C54.9959 124.552 64.563 124.552 33.0175 106.343C1.47997 88.1326 6.25958 96.4199 6.25958 60C6.25958 23.5801 1.47207 31.8674 33.0175 13.6575C64.5551 -4.55249 54.988 -4.55249 86.5335 13.6575Z",
    fill: "url(#paint0_linear_965_172121)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.301 29.3078C114.603 34.0875 113.291 40.8895 113.291 59.9922C113.291 96.4121 118.079 88.1248 86.5335 106.335C68.7106 116.629 64.01 121.1 57.603 119.757C54.3007 114.978 55.6121 108.175 55.6121 89.0728C55.6121 52.6529 50.8246 60.9402 82.3701 42.7303C100.201 32.4363 104.894 27.9648 111.301 29.3078Z",
    fill: "url(#paint1_linear_965_172121)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25043 29.0706C4.94815 33.8502 6.25958 40.6523 6.25958 59.755C6.25958 96.1749 1.47207 87.8876 33.0175 106.098C46.5585 113.911 52.5231 118.374 57.4133 119.48C54.3481 114.717 55.6121 107.812 55.6121 89.0726C55.6121 66.4701 53.7714 61.0901 59.9177 55.8997C56.2204 52.6448 49.4499 49.5716 37.1809 42.4852C19.3502 32.1912 14.6575 27.7197 8.25043 29.0627",
    fill: "#9798BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.485 26.4481L59.8228 49.3586L18.6865 26.4639L59.3488 3.5533L100.485 26.4481ZM105.762 26.4481L59.3172 0.598633L13.4092 26.4718L59.8544 52.3212L105.762 26.4481ZM77.2902 16.478C87.1654 21.9766 87.2602 30.9275 77.4956 36.426C67.7309 41.9245 51.7488 41.9324 41.8736 36.4339C31.9983 30.9354 31.9035 21.9845 41.6682 16.4859C51.4328 10.9874 67.4149 10.9795 77.2902 16.478ZM79.913 15.0007C68.5525 8.68053 50.2399 8.68053 39.0137 15.0086C27.7875 21.3366 27.8902 31.5911 39.2507 37.9112C50.6112 44.2314 68.9239 44.2314 80.15 37.9034C91.3762 31.5753 91.2735 21.3208 79.913 15.0007ZM74.8411 34.9566C83.1758 30.2639 83.0968 22.656 74.6673 17.9633C66.2378 13.2705 52.6495 13.2784 44.3226 17.9633C35.9879 22.656 36.0669 30.2639 44.4965 34.9566C52.926 39.6493 66.5143 39.6414 74.8411 34.9566Z",
    fill: "#9798BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.97 79.5C89.76 82.44 87 85.01 84.01 86.7C81.02 88.39 78.26 88.94 76.05 88.49V97.85L91.97 88.85V79.49V79.5ZM94.66 76.43L94.32 76.62V87.54L104.03 82.05V80.51C104.03 75.34 99.83 73.51 94.66 76.44V76.43ZM73.71 88.27L73.37 88.46C68.2 91.38 64 97.96 64 103.13V104.67L73.71 99.18V88.26V88.27ZM88.71 53.16V61.65L94.69 58.27C94.48 56.48 93.78 55.08 92.61 54.18C91.58 53.39 90.23 53.05 88.7 53.16H88.71ZM75.41 63.9C74.25 66.11 73.54 68.31 73.33 70.34L79.31 66.96V58.47C77.78 60.08 76.43 61.96 75.4 63.91L75.41 63.9ZM84.02 84.36C89.94 81.01 94.76 73.47 94.76 67.55V65.86L73.28 78V79.69C73.28 85.61 78.1 87.71 84.02 84.36ZM81.67 54.65L86.36 52V62.98L81.67 65.63V54.65ZM70.63 74.21L97.39 59.08V62.01L70.63 77.15V74.22V74.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_172121",
    x1: 60,
    y1: 51,
    x2: 57.9868,
    y2: 12.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9798BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_965_172121",
    x1: 62.9998,
    y1: 58,
    x2: 97.9998,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9798BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE3F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome5);
export default __webpack_public_path__ + "static/media/home5.4f6daa42.svg";
export { ForwardRef as ReactComponent };